import type RouteBase from "@/utils/routes/RouteBase";

const getRouteParentsRecursively = (sourceRoute: RouteBase): RouteBase[] => {
  const routeArr: RouteBase[] = [];

  if (sourceRoute?.parent) {
    routeArr.push(sourceRoute, ...getRouteParentsRecursively(sourceRoute.parent));
  } else {
    routeArr.push(sourceRoute);
  }

  return routeArr;
};

export default getRouteParentsRecursively;
